export default __webpack_public_path__ + "static/media/team-1.fa5a7ac2.jpg";